const stepperUp = {
    svg: '<svg style="width:1.00rem; height:0.75rem;" viewBox="0 0 16 12"><polygon points="4.5 9.75 8 6.25 11.5 9.75"/></svg>',
};

export { stepperUp as default };
